import useSwr from 'swr';

import { Faq, faqSchema } from '@/api/faq/faq-schema';
import { config } from '@/config/app.config';
import { validateFetcher } from '@/utils/validateFetcher';

export const useFaqData = () => {
  const faqRoute = new URL(
    '/api/earnings-faq?populate=faqs',
    config.urls.cmsApiPath
  );
  const { data, error } = useSwr<Faq>(
    {
      endpoint: faqRoute.href,
      schema: faqSchema,
    },
    validateFetcher,
    {
      revalidateOnFocus: false,
    }
  );

  return {
    data,
    loading: !data && !error,
    error,
  };
};
